'use client';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Up next / autoplay controls for the in-series player.
 */
export interface PlaylistControlsProps {
  totalEpisodes: number;
  currentIndex: number;
  onPrev?: () => void;
  onNext?: () => void;
  autoplay?: boolean;
  onToggleAutoplay?: (next: boolean) => void;
}

export function PlaylistControls({
  totalEpisodes,
  currentIndex,
  onPrev,
  onNext,
  autoplay = true,
  onToggleAutoplay,
}: PlaylistControlsProps) {
  const { t } = useTranslation('site-builder-blocks');
  const [localAutoplay, setLocalAutoplay] = useState(autoplay);
  const toggle = () => {
    const next = !localAutoplay;
    setLocalAutoplay(next);
    onToggleAutoplay?.(next);
  };
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        padding: 'var(--space-3, 12px) var(--space-4, 16px)',
        background: 'var(--color-surface-card, #fff)',
        border: '1px solid var(--color-border, rgba(0,0,0,0.08))',
        borderRadius: 8,
      }}
    >
      <button type="button" onClick={onPrev} disabled={!onPrev || currentIndex === 0} style={ctrl}>
        {t('playlist.prev')}
      </button>
      <div style={{ fontSize: '13px', color: 'var(--color-text-secondary, #71717a)' }}>
        {t('playlist.episodeOf', { current: currentIndex + 1, total: totalEpisodes })}
      </div>
      <button
        type="button"
        onClick={onNext}
        disabled={!onNext || currentIndex >= totalEpisodes - 1}
        style={ctrl}
      >
        {t('playlist.next')}
      </button>
      <label
        style={{
          marginLeft: 'auto',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          fontSize: '13px',
        }}
      >
        <input type="checkbox" checked={localAutoplay} onChange={toggle} />
        {t('playlist.autoplay')}
      </label>
    </div>
  );
}

const ctrl = {
  padding: 'var(--space-1-5, 6px) var(--space-3, 12px)',
  border: '1px solid var(--color-border, rgba(0,0,0,0.12))',
  borderRadius: 6,
  background: 'transparent',
  cursor: 'pointer',
  fontSize: '13px',
  fontWeight: 500,
};
